import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import type { BedPolicyDetails } from '@shared/types/hotel-content';

import STYLES from './BedPolicy.module.scss';

const cls = cssModules(STYLES);

type Props = {
  policy: BedPolicyDetails;
  key: string;
};

const BedPolicy = ({ key, policy }: Props) => (
  <div className={cls('BedPolicy')}>
    {policy.title && (
      <BpkText textStyle={TEXT_STYLES.bodyDefault} tagName="p">
        {policy.title}
      </BpkText>
    )}
    {policy.items.map((item) => (
      <div className={cls('BedPolicy__policyList')} key={key}>
        <BpkText
          tagName="p"
          textStyle={TEXT_STYLES.label1}
          className={cls('BedPolicy__limitDescription')}
          color={TEXT_COLORS.textPrimary}
        >
          {item.limitDescription}
        </BpkText>
        <BpkText
          tagName="p"
          className={cls('BedPolicy__content')}
          color={TEXT_COLORS.textSecondary}
        >
          {item.payDescription}
        </BpkText>
      </div>
    ))}
  </div>
);

export default BedPolicy;
